export const DROPDOWN_STYLES = { maxHeight: 352, maxWidth: 600 }
